import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useApp();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const session_id = params.get("session_id");

    if (!session_id) {
      navigate("/admin", { replace: true });
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        // Persist session_token as Bearer fallback → admin stays logged in even
        // if 3rd-party cookies get blocked (iOS Safari, strict Chrome).
        if (data?.session_token) {
          try { localStorage.setItem("ikz_session_token", data.session_token); } catch {}
        }
        setUser(data);
        window.history.replaceState(null, "", window.location.pathname);
        if (!data.is_admin) {
          toast.error("Bu e-posta yönetim paneline erişim izni yok.");
        }
        navigate(window.location.pathname, { replace: true, state: { user: data } });
      } catch (e) {
        toast.error("Giriş başarısız");
        navigate(window.location.pathname, { replace: true });
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#FAF7F2] flex items-center justify-center">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto mb-4 rounded-full border-4 border-[#2E5A36] border-t-transparent animate-spin" />
        <p className="font-heading font-bold text-[#1B2A22]">Giriş yapılıyor...</p>
      </div>
    </div>
  );
}
